import { StyledPlayVideo } from './PlayVideo.styled';
import { useContext } from 'react';
import { AppContext } from '../../providers/AppContext';

export default function PlayVideo() {
  const { setShowVideo } = useContext(AppContext);
  return (
    <StyledPlayVideo>
      {/*<img src='/assets/full_video.svg' onClick={() => setShowVideo(true)}/>*/}
    </StyledPlayVideo>
  );
}
